import type { TOptions } from 'i18next';
import { EditIcon } from 'lucide-react';
import { useInlineTranslationDialog } from './InlineTranslationProvider';
// eslint-disable-next-line no-restricted-imports
import { useTranslation } from 'react-i18next';
import { useKeyStore } from './hooks/useKeyStore';

export type TProps = { k: string; options?: TOptions };

export const T = ({ k: key, options }: TProps) => {
  const { t, i18n } = useTranslation(options?.ns);
  const { editMode, openDialog } = useInlineTranslationDialog();
  const { addKey } = useKeyStore();

  const ns = options?.ns?.toString() || i18n.options.defaultNS?.toString();
  addKey(key, ns, !!options?.count);

  const translation = t(key, options);
  if (!editMode) {
    return translation;
  }

  return (
    <span
      data-key={key}
      data-namespace={options?.ns}
      className='eye:relative eye:inline-block'
    >
      {translation}
      <span
        className={'eye:cursor-pointer'}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          openDialog({ key, options });
        }}
        title='Edit translation'
      >
        <EditIcon
          className={
            'eye:size-12 eye:bg-black! eye:text-white! eye:absolute eye:left-[-2px] eye:top-[-2px]'
          }
          aria-hidden
        />
      </span>
    </span>
  );
};
